export default __webpack_public_path__ + "static/cigus-es-1a825dc33833f7ed7aaf212cee757de7.svg";